import {useCallback, useEffect} from 'react';

import {assertAndContinue} from 'Asserts';
// @ts-expect-error
import formatters from 'notebook/mediocre/formatted-text/formatters';
import {ctrl} from 'util/Keyboard';

export function useFormatShortcut(
  format: string,
  onActivate: (format: string) => void,
  {disabled}: {disabled?: boolean} = {}
): string {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent): void => {
      const eventFormat = formatters.formatTypeFromKeydown(event);
      if (eventFormat !== format) {
        return;
      }
      onActivate(format);
      event.preventDefault();
    },
    [format, onActivate]
  );

  useEffect(() => {
    if (disabled) {
      return;
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown, disabled]);

  const shortcut = formatters.getFormatShortcut(format);
  assertAndContinue(shortcut != null, `No shortcut found for format ${format}`);
  return shortcut.replace('Ctrl', ctrl);
}
